export default __webpack_public_path__ + "static/media/paypal.da102125.svg";